export const customerIndividualSelector = (state: StateType): ?Object => state.customer.data?.individual;

export const customerIndividualIdentificationsSelector = (state: StateType): ?(Object[]) => {
  const individual = customerIndividualSelector(state);
  return individual?.identifications;
};

export const customerIndividualContactMediumsSelector = (state: StateType): ?(Object[]) => {
  const individual = customerIndividualSelector(state);
  return individual?.contactMediums;
};

export const hasBillingAddressContactMedium = (state: StateType): boolean => {
  const contactMediums = customerIndividualContactMediumsSelector(state);
  return contactMediums && contactMediums.some(contactMedium => contactMedium.type === 'BILLING_ADDRESS');
};
